const generatePlacesDataset = () => {
  const cityIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 19"><path d="M12 9V3L9 0 6 3v2H0v14h18V9h-6zm-8 8H2v-2h2v2zm0-4H2v-2h2v2zm0-4H2V7h2v2zm6 8H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V7h2v2zm0-4H8V3h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z" /></svg>';
  const pinIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 14 20"><path d="M7 0C3.13 0 0 3.13 0 7c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5C5.62 9.5 4.5 8.38 4.5 7S5.62 4.5 7 4.5 9.5 5.62 9.5 7 8.38 9.5 7 9.5z"/></svg>';

  const getSuggestionIcon = (placeType) => {
    if (placeType.includes('country') || placeType.includes('region') || placeType.includes('district') || placeType.includes('place')) {
      return cityIcon;
    }

    return pinIcon;
  };

  return {
    source(query, callback) {
      const mapboxURL = new URL(`https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json`);
      mapboxURL.searchParams.set('access_token', process.env.MAPBOX_ACCESS_TOKEN);
      mapboxURL.searchParams.set('country', 'fr,gf,pf,gp,pm,re,mq');
      mapboxURL.searchParams.set('types', 'region,district,postcode,place,address,neighborhood,locality,poi');
      mapboxURL.searchParams.set('bbox', '-62.08903070836374,-21.482683215594875,56.04047305573917,51.11023709996738');
      mapboxURL.searchParams.set('language', 'fr');
      fetch(mapboxURL)
        .then((response) => response.json())
        .then((data) => {
          callback(data.features);
        }, () => callback([]));
    },
    name: 'places',
    displayKey(suggestion) {
      return suggestion.place_name;
    },
    templates: {
      suggestion(suggestion) {
        return `
          <div class="suggestion" role="option">
              <div>
                  <i class="suggestion-icon">
                    ${getSuggestionIcon(suggestion.place_type)}
                  </i>
                  <div class="col-algolia2">
                    ${suggestion.text}
                    <span class="suggestion-address"> ${suggestion.place_name}</span>
                  </div>
              </div>
          </div>
        `;
      },
    },
    debounce: 300,
  };
};

function generatePointsDataset() {
  const pinIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 14 20"><path d="M7 0C3.13 0 0 3.13 0 7c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5C5.62 9.5 4.5 8.38 4.5 7S5.62 4.5 7 4.5 9.5 5.62 9.5 7 8.38 9.5 7 9.5z"/></svg>';

  return {
    source: (query, callback) => {
      fetch(`/api/web/v1/recovery_points/locations/suggestions?search=${query}`)
        .then((response) => response.json())
        .then((data) => callback(data))
        .catch(() => callback([]));
    },
    name: 'api',
    displayKey: (suggestion) => `${suggestion.name}`,
    templates: {
      header: '<div style="background-color: #e8e8e8; font-weight: 700; padding: 5px" class="api-header">Centres de récupération</div>',
      suggestion: (suggestion) => `
        <div class="suggestion api-suggestion" role="option">
          <i class="suggestion-icon">${pinIcon}</i>
          <div class="col-algolia2">
            <div>${suggestion.name}</div>
            <div class="suggestion-address">${suggestion.address}</div>
          </div>
        </div>
      `,
    },
    debounce: 300,
  };
}

export const AlgoliaService = {
  generatePlacesDataset,
  generatePointsDataset,
};
